import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.36361 4.36369C4.53238 4.19496 4.76126 4.10018 4.99991 4.10018C5.23855 4.10018 5.46743 4.19496 5.63621 4.36369L9.49991 8.22739L13.3636 4.36369C13.4466 4.27773 13.5459 4.20916 13.6557 4.162C13.7655 4.11483 13.8836 4.09 14.0031 4.08896C14.1226 4.08792 14.2412 4.1107 14.3518 4.15595C14.4624 4.2012 14.5629 4.26803 14.6474 4.35253C14.7319 4.43704 14.7987 4.53752 14.8439 4.64813C14.8892 4.75874 14.912 4.87725 14.9109 4.99675C14.9099 5.11625 14.8851 5.23435 14.8379 5.34415C14.7907 5.45396 14.7222 5.55327 14.6362 5.63629L10.7725 9.49999L14.6362 13.3637C14.8001 13.5334 14.8909 13.7608 14.8888 13.9967C14.8868 14.2327 14.7921 14.4585 14.6252 14.6253C14.4584 14.7922 14.2326 14.8868 13.9967 14.8889C13.7607 14.8909 13.5333 14.8002 13.3636 14.6363L9.49991 10.7726L5.63621 14.6363C5.46646 14.8002 5.23912 14.8909 5.00314 14.8889C4.76717 14.8868 4.54144 14.7922 4.37457 14.6253C4.2077 14.4585 4.11305 14.2327 4.111 13.9967C4.10895 13.7608 4.19966 13.5334 4.36361 13.3637L8.22731 9.49999L4.36361 5.63629C4.19488 5.46751 4.1001 5.23864 4.1001 4.99999C4.1001 4.76134 4.19488 4.53246 4.36361 4.36369Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}